import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getPRQ(params, signal) {
  return request({
    url: '/prqTimerCycleHistory',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getPRQTotal(params, signal) {
  return request({
    url: '/prqTimerCycleHistory/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getExelExport(params) {
  return request({
    url: '/prqTimerCycleHistory/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function deletePrq(uuid) {
  return request({
    url: `/prqTimerCycleHistory/${uuid}`,
    method: 'delete',
  });
}
